import { c as _c } from "react/compiler-runtime";
import type { UserTimelineEventConditionalBranchExecuted } from '@onefootprint/request-types/dashboard';
import { Trans, useTranslation } from 'react-i18next';
import { OnboardingTraceLink } from '@/components/onboarding-trace-link';
export const ConditionalBranchExecutedHeader = t0 => {
  const $ = _c(17);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.conditionalBranchStepUp"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== data.branchName) {
    t2 = {
      branchName: data.branchName
    };
    $[1] = data.branchName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      b: <b className="text-label-2 text-primary" />
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div className="inline text-body-2 text-primary md:block"><Trans ns="entity-details" i18nKey={_temp} values={t2} components={t3} /></div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex items-center justify-center mx-0.5">·</div>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = data.onboardingId;
  const t7 = data.playbook;
  let t8;
  if ($[7] !== t) {
    t8 = t(_temp2);
    $[7] = t;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== data.nodeId || $[10] !== data.onboardingId || $[11] !== data.playbook || $[12] !== t8) {
    t9 = <div className="inline-flex items-center justify-center gap-1 ml-1 md:flex md:ml-0">{t5}<OnboardingTraceLink onboardingId={t6} playbook={t7} label={t8} nodeId={data.nodeId} /></div>;
    $[9] = data.nodeId;
    $[10] = data.onboardingId;
    $[11] = data.playbook;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t4 || $[15] !== t9) {
    t10 = <div className="md:flex md:items-center md:gap-1">{t4}{t9}</div>;
    $[14] = t4;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
function _temp($) {
  return $.auditTrail.timeline.conditionalBranchStepUp.title;
}
function _temp2($_0) {
  return $_0.viewDetails;
}